"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = require("react");
var TICK_TIMEOUT = 50;
function injectRemovedChilds(removedChilds, children) {
    var childrenClone = children.slice();
    var childrenMaxIndex = children.length - 1;
    removedChilds.forEach(function (_a) {
        var element = _a.element, index = _a.index;
        if (index > childrenMaxIndex) {
            childrenClone.push(element);
        }
        else {
            childrenClone.splice(index, 0, element);
        }
    });
    return childrenClone;
}
function getExitTimeout(child) {
    var _a = child.props, timeout = _a.timeout, delay = _a.delay;
    var exitTimeout = typeof timeout === 'number' ? timeout : timeout.exit;
    if (delay) {
        var exitDelay = typeof delay === 'number' ? delay : delay.exit;
        return exitTimeout + exitDelay + TICK_TIMEOUT;
    }
    return exitTimeout + TICK_TIMEOUT;
}
var TransitionGroup = /** @class */ (function (_super) {
    tslib_1.__extends(TransitionGroup, _super);
    function TransitionGroup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { children: _this.props.children };
        return _this;
    }
    TransitionGroup.prototype.componentDidUpdate = function (prevProps) {
        var _this = this;
        if (prevProps !== this.props) {
            var remvovedChilds_1 = this.getRemovedChilds();
            var newChildren = injectRemovedChilds(remvovedChilds_1, this.props.children);
            this.setState({ children: newChildren }, function () {
                remvovedChilds_1.forEach(function (child) {
                    var timeout = getExitTimeout(child.element);
                    setTimeout(function () { return _this.removeChild(child.element.key); }, timeout);
                });
            });
        }
    };
    TransitionGroup.prototype.getRemovedChilds = function () {
        var childrenState = this.state.children;
        var children = this.props.children;
        var removedChilds = childrenState
            .map(function (child, index) {
            var exists = children.some(function (_a) {
                var key = _a.key;
                return key === child.key;
            });
            if (exists) {
                return null;
            }
            return {
                index: index,
                element: react_1.cloneElement(child, { displayed: false }),
            };
        })
            .filter(function (child) { return !!child; });
        return removedChilds;
    };
    TransitionGroup.prototype.removeChild = function (key) {
        this.setState(function (_a) {
            var children = _a.children;
            var childIndex = children.findIndex(function (child) { return child.key === key; });
            if (childIndex >= 0) {
                var childToRemove = children[childIndex];
                if (childToRemove.props.displayed === false) {
                    var childrenClone = children.slice();
                    childrenClone.splice(childIndex, 1);
                    return { children: childrenClone };
                }
            }
            return null;
        });
    };
    TransitionGroup.prototype.render = function () {
        return this.state.children;
    };
    return TransitionGroup;
}(react_1.Component));
exports.default = TransitionGroup;
